import { DisputeResponse, Dispute } from '../payments.types';

const customer = {
  customer_name: 'Test User',
  customer_email_address: 'testuser@test.com',
  billing_address: '55555',
  customer_purchase_ip: '192.168.0.1',
};

const baseDispute: Dispute = {
  id: 'dp_1MtJUT2eZvKYlo2CNaw2HvEv',
  object: 'dispute',
  amount: 1000,
  balance_transactions: [],
  charge: { id: 'ch_1AZtxr2eZvKYlo2CJDX8whov' },
  created: 1680651737,
  currency: 'usd',
  evidence: {
    access_activity_log: null,
    billing_address: null,
    cancellation_policy: null,
    cancellation_policy_disclosure: null,
    cancellation_rebuttal: null,
    customer_communication: null,
    customer_email_address: null,
    customer_name: null,
    customer_purchase_ip: null,
    customer_signature: null,
    duplicate_charge_documentation: null,
    duplicate_charge_explanation: null,
    duplicate_charge_id: null,
    product_description: null,
    receipt: null,
    refund_policy: null,
    refund_policy_disclosure: null,
    refund_refusal_explanation: null,
    service_date: null,
    service_documentation: null,
    shipping_address: null,
    shipping_carrier: null,
    shipping_date: null,
    shipping_documentation: null,
    shipping_tracking_number: null,
    uncategorized_file: null,
    uncategorized_text: null,
  },
  evidence_details: {
    due_by: 1782294399,
    has_evidence: false,
    past_due: false,
    submission_count: 0,
  },
  is_charge_refundable: true,
  livemode: false,
  metadata: {},
  payment_intent: null,
  reason: 'general',
  status: 'warning_needs_response',
};

const baseDisputeResponse: DisputeResponse = {
  disputeId: '',
  // chargeId: 'ch_3Ny8iWKdZ3YHmMQb0200exBo',
  paymentIntentId: 'pi_3Ny8iWKdZ3YHmMQb0NKbuneZ',
  amount: 10000,
  clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
  stripeAccountId: 'acct_1LmKQpQKILVC4wUm',
  incentivioChargeType: 'ORDER',
  incentivioEntityId: '65cf2fe9eedc7658c99e9531',
  reversalAmount: 10000,
  createdDate: '2023-04-04T07:45:08.148Z',
  reversalDate: '2023-10-06T07:45:08.148Z',
  transferId: 'tr_1Ny8icKdZ3YHmMQbp0wnWj0Y',
  balanceTransactionStatus: 'WITHDRAWN',
  uploadedFileIds: [],
  customerName: 'Deluxan Mariathasan',
  customerEmail: 'deluxan.m@incentivio.com',
  userId: '02e4d2f5-2f4e-44cd-833f-d4c7e2e408ab',
  paymentMethod: {
    paymentMethodId: 'pm_1Ny6oNKdZ3YHmMQboczsxYC5',
    billingZip: '12345',
    type: 'card',
    cardBrand: 'visa',
    lastFour: '0259',
    expirationMonth: 12,
    expirationYear: 2023,
  },
  events: [
    {
      eventId: 'evt_1OD1jJKdZ3YHmMQb28HOao0E',
      status: 'needs_response',
      intermediateStatus: 'dispute_created',
      createdDate: '2023-11-16T09:19:22.121Z',
    },
    {
      eventId: 'evt_3OD1jFKdZ3YHmMQb0gCjLEIN',
      status: 'needs_response',
      intermediateStatus: 'funds_withdrawn',
      createdDate: '2023-11-16T09:19:23.740Z',
    },
    {
      eventId: 'file_1OD1oMKdZ3YHmMQbvmgCcGWj',
      status: 'needs_response',
      intermediateStatus: 'evidence_uploaded',
      createdDate: '2023-11-16T09:24:35.717Z',
    },
    {
      eventId: 'evt_3OD1jFKdZ3YHmMQb0cvHXsML',
      status: 'under_review',
      intermediateStatus: 'dispute_updated',
      createdDate: '2023-11-16T09:27:48.825Z',
    },
    {
      eventId: 'evt_3OD1jFKdZ3YHmMQb07YJBV4G',
      status: 'won',
      intermediateStatus: 'dispute_closed',
      createdDate: '2023-11-16T09:27:50.036Z',
    },
  ],
  disputeFee: 15000,
  processingFee: 1000,
  adminAccepted: false,
  stripeBody: baseDispute,
};

const makeDisputeResponse = (
  dispute: Partial<Dispute> & { id: string },
  disputeResponse?: Partial<DisputeResponse>,
): DisputeResponse => ({
  ...baseDisputeResponse,
  ...disputeResponse,
  disputeId: dispute.id,
  stripeBody: {
    ...baseDispute,
    ...dispute,
  },
});

export const disputes: Record<string, DisputeResponse> = {
  lost: makeDisputeResponse({
    id: 'lost',
    status: 'lost',
    reason: 'bank_cannot_process',
    evidence: { ...customer, customer_signature: { id: 'asdf' } },
  }),
  needs_response: makeDisputeResponse({
    id: 'needs_response',
    status: 'needs_response',
    reason: 'check_returned',
    evidence: { ...customer },
  }),
  under_review: makeDisputeResponse({
    id: 'under_review',
    status: 'under_review',
    reason: 'credit_not_processed',
    evidence: { ...customer },
  }),
  warning_closed: makeDisputeResponse({
    id: 'warning_closed',
    status: 'warning_closed',
    reason: 'customer_initiated',
    evidence: { ...customer },
  }),
  warning_needs_response: makeDisputeResponse({
    id: 'warning_needs_response',
    status: 'warning_needs_response',
    reason: 'debit_not_authorized',
    currency: 'cad',
    evidence: { ...customer },
  }),
  warning_under_review: makeDisputeResponse({
    id: 'warning_under_review',
    status: 'warning_under_review',
    reason: 'duplicate',
    evidence: { ...customer },
  }),
  won: makeDisputeResponse(
    {
      id: 'won',
      status: 'won',
      reason: 'fraudulent',
      evidence: { ...customer },
      evidence_details: {
        has_evidence: false,
        past_due: false,
        submission_count: 0,
        due_by: 1182294399,
      },
    },
    {
      events: [
        {
          status: 'under_review',
          createdDate: '2023-11-15T09:19:22.121Z',
          eventId: 'asdf',
          intermediateStatus: 'asdf',
        },
        {
          status: 'won',
          createdDate: '2023-11-16T09:19:22.121Z',
          eventId: 'asdf',
          intermediateStatus: 'asdf',
        },
      ],
    },
  ),
  deadline_missed: makeDisputeResponse({
    id: 'deadline_missed',
    status: 'needs_response',
    reason: 'bank_cannot_process',
    evidence: { ...customer, customer_signature: { id: 'asdf' } },
    evidence_details: {
      has_evidence: false,
      past_due: false,
      submission_count: 0,
      due_by: 1182294399,
    },
  }),
  warning_deadline_missed: makeDisputeResponse({
    id: 'warning_deadline_missed',
    status: 'warning_needs_response',
    reason: 'bank_cannot_process',
    evidence: { ...customer, customer_signature: { id: 'asdf' } },
    evidence_details: {
      has_evidence: false,
      past_due: false,
      submission_count: 0,
      due_by: 1182294399,
    },
  }),
  dp_1Ny8iZKdZ3YHmMQbyfzX1hjA_7: makeDisputeResponse({
    id: 'dp_1Ny8iZKdZ3YHmMQbyfzX1hjA_7',
    reason: 'general',
    evidence: {
      ...customer,
      uncategorized_file: { id: 'file id' },
      uncategorized_text:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      cancellation_policy: { id: 'file id' },
      cancellation_policy_disclosure:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      cancellation_rebuttal:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      billing_address:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      customer_name:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      customer_email_address:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      customer_signature: { id: 'file id' },
      customer_communication: { id: 'file id' },
      receipt: { id: 'file id' },
      access_activity_log:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      customer_purchase_ip:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      duplicate_charge_documentation: { id: 'file id' },
      duplicate_charge_explanation:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      duplicate_charge_id:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      refund_policy: { id: 'file id' },
      refund_policy_disclosure:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      refund_refusal_explanation:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      service_date: '2023-10-06',
      service_documentation: { id: 'file id' },
      shipping_address:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      shipping_carrier:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      shipping_date: '2023-10-06',
      shipping_documentation: { id: 'file id' },
      shipping_tracking_number:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      product_description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    },
  }),
  dp_1Ny8iZKdZ3YHmMQbyfzX1hjA_8: makeDisputeResponse(
    {
      id: 'dp_1Ny8iZKdZ3YHmMQbyfzX1hjA_8',
      reason: 'incorrect_account_details',
      evidence: { ...customer },
    },
    {
      incentivioChargeType: 'GIFTCARD_ADD_FUNDS',
    },
  ),
  dp_1Ny8iZKdZ3YHmMQbyfzX1hjA_9: makeDisputeResponse(
    {
      id: 'dp_1Ny8iZKdZ3YHmMQbyfzX1hjA_9',
      reason: 'insufficient_funds',
      evidence: { ...customer },
    },
    {
      incentivioChargeType: 'GIFTCARD_PURCHASE',
    },
  ),
  dp_1Ny8iZKdZ3YHmMQbyfzX1hjA_10: makeDisputeResponse(
    {
      id: 'dp_1Ny8iZKdZ3YHmMQbyfzX1hjA_10',
      reason: 'product_not_received',
      evidence: { ...customer },
    },
    {
      incentivioChargeType: 'SCAN_TO_PAY',
    },
  ),
  dp_1Ny8iZKdZ3YHmMQbyfzX1hjA_11: makeDisputeResponse({
    id: 'dp_1Ny8iZKdZ3YHmMQbyfzX1hjA_11',
    reason: 'product_unacceptable',
    evidence: { ...customer },
  }),
};
